import { useAuthFetch } from "matsuri-hooks"
import { User } from "@/model/user"
import { m2mUsers_v1 } from "@/endpoints/m2m-users.v1"

export const useFindUserById = (token: string, id: string | undefined) => {
    return useAuthFetch<User>(
        token,
        id ? m2mUsers_v1.findUserById({ id }) : null,
        {}
    )
}
